<template>
  <div class="waller-statistics" v-if="billData">
    <div class="title">
      <div class="icon">
        <van-icon name="balance-o" color="#ae8b6c" size="32" />
      </div>
      <div class="text">我的钱包</div>
    </div>
    <p class="all-money">
      ￥<span>{{ billData.balance }}</span>
    </p>
    <p>总资产</p>
    <div class="type-box">
      <div class="type">
        <div class="item">
          总收入
          <p class="in">￥{{ billData.income_total }}</p>
        </div>
        <div class="item">
          总支出
          <p class="out">￥{{ billData.expense_total }}</p>
        </div>
      </div>
    </div>
    <div class="btn">
      <van-button
        icon="paid"
        block
        round
        style="
          border: 1px solid #b88d5e;
          background: linear-gradient(to right, #a77145, #cdaa8a);
          color: #fff;
        "
        v-if="safeUsr && safeUsr.wstatus == 1"
        @click="showdeposit = true"
        >申请提现</van-button
      >
    </div>
    <van-popup
      v-model="showdeposit"
      v-if="showdeposit"
      class="edit-box"
      :style="{ width: '80%' }"
      closeable 
    >
      <div class="frm-area">
        <div class="title">提现申请</div>
        <div class="frm-box">
          <van-form @submit="onSubmit">
            <div class="frm-item">
             <div style="margin: 6px 12px">
                <van-radio-group v-model="frm.type" direction="horizontal">
                  <van-radio name="1">支付宝</van-radio>
                  <van-radio name="2">微信</van-radio>
                  <van-radio name="3">银行卡</van-radio>
                </van-radio-group>
              </div>
            </div>
            <div class="frm-item">
              <div class="frm-label">提现金额</div>
              <van-field
                v-model="frm.amount"
                placeholder="请填写提现金额"
                :rules="[
                  {
                    required: true,
                    message: '请填写提现金额'
                  }
                ]"
              />
            </div>
            
            <div class="frm-item">
              <div class="frm-label">确认密码</div>
              <van-field
                v-model="frm.paypwd"
                placeholder="请填写交易密码"
                :rules="[{ required: true, message: '请填写交易密码' }]"
              />
            </div>
            <div class="btn-box">
              <van-button
                block
                native-type="submit"
                :loading="posting"
                loading-text="提交中..."
                style="
                  background-color: #141423;
                  color: #fff;
                  border-radius: 8px;
                "
                >申请</van-button
              >
            </div>
          </van-form>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'WallerStatistics',
  props:['usr'],
  computed:{
    safeUsr(){
      return this.usr || null
    }
  },
  data () {
    return {
      billData: null,
      showdeposit: false,
      posting: false,
      frm: {
        type:null,
        amount: null,
        paypwd: null
      }
    }
  },
  watch: {
    showdeposit (val) {
      if (val) {
        this.frm = {
          type:null,
          amount: null,
          paypwd: null
        }
      }
    }
  },
  mounted () {
    this.billsummary()
  },
  methods: {
    async billsummary () {
      await this.$http({
        method: 'post',
        url: 'billSummary'
      }).then(res => {
        this.billData = res.data
      })
    },
    async onSubmit () {
      if (this.posting) {
        return
      }
      this.posting = true

      await this.$http({
        method: 'post',
        url: 'deposit',
        data: this.frm
      })
        .then(res => {
          this.$toast.success(res.msg)
          this.posting = false
          this.showdeposit = false
          this.billsummary()
          this.$emit('reset-record')
        })
        .catch(() => {
          this.posting = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.waller-statistics {
  margin: 40px 10px;
  padding: 15px 12px;
  background: linear-gradient(135deg, #452d22, #cba273);
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  color: #fff;
  text-align: center;
  position: relative;
  .title {
    height: 34px;
    line-height: 34px;
    display: flex;
    gap: 8px;
    .text {
      font-size: 20px;
      font-weight: 600px;
    }
  }
  .all-money {
    margin: 10px 0;
    span {
      font-weight: 600;
      font-size: 24px;
      margin-left: 8px;
    }
  }
  .type-box {
    position: relative;
    .type {
      margin: 10px 30px;
      border: 1px solid #9f5f36;
      border-radius: 10px;
      display: flex;
      padding: 15px;
      .item {
        flex: 1;
        p {
          height: 38px;
          line-height: 38px;
          font-size: 18px;
        }
        .in {
          color: #b5e1b0;
        }
        .out {
          color: #f1b79e;
        }
      }
    }
    .type::after {
      content: '';
      position: absolute;
      bottom: 25px;
      left: 50%;
      transform: translateX(-50%);
      width: 1px;
      height: 50px;
      background: linear-gradient(
        to bottom,
        transparent,
        rgba(255, 255, 255, 0.6),
        transparent
      );
      z-index: 2;
    }
  }
  .btn {
    margin: 16px auto;
    width: 40%;
  }
}

.edit-box {
  margin: 40px 10px;
  padding: 15px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  color: #000 !important;
  text-align: left !important;
  .frm-area {
    .title {
      height: 38px;
      line-height: 38px;
      font-size: 18px;
      font-weight: 550;
      border-bottom: 1px solid #dcdee0;
    }
    .frm-box {
      margin: 8px 0;
      .frm-label {
        text-indent: 14px;
        font-size: 14px;
        margin-top: 10px;
      }
      .btn-box {
        margin: 16px 0 0;
        text-align: right;
      }
    }
  }
}
</style>
